import { defineMessages } from 'react-intl'

export const sysMonErrorMessages = defineMessages({
  oldVersionTitle: {
    id: 'sysMonError.oldVersionTitle',
    description:
      'A title shown on error screen when current host version does not support system monitor feature',
    defaultMessage: 'SavantOS 10.2 or later required',
  },
})
